import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';
import { BookOpen, Calendar, CheckCircle } from 'lucide-react';

export default function TeacherDashboard() {
  const { user } = useAuth();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const response = await api.get('/dashboard/teacher');
      setDashboardData(response.data);
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Greeting */}
      <div>
        <h2 className="font-outfit font-semibold text-3xl text-slate-800 mb-2">
          Good Morning, {user?.name}! 👋
        </h2>
        <p className="text-slate-500">Ready to inspire young minds today?</p>
      </div>

      {/* Assigned Classes */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
        <div className="flex items-center gap-3 mb-6">
          <BookOpen className="w-5 h-5 text-green-600" />
          <h3 className="font-outfit font-semibold text-xl text-slate-800">Your Classes</h3>
        </div>
        {dashboardData?.assignedClasses?.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {dashboardData.assignedClasses.map((classItem) => (
              <div key={classItem.id} className="p-4 bg-green-50 border border-green-100 rounded-xl">
                <p className="font-medium text-slate-800">{classItem.className}</p>
                <p className="text-sm text-slate-500">{classItem.sessionYear}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-slate-500 text-center py-8">No classes assigned yet</p>
        )}
      </div>

      {/* Upcoming Exams */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
        <div className="flex items-center gap-3 mb-6">
          <Calendar className="w-5 h-5 text-green-600" />
          <h3 className="font-outfit font-semibold text-xl text-slate-800">Upcoming Exams</h3>
        </div>
        {dashboardData?.upcomingExams?.length > 0 ? (
          <div className="space-y-3">
            {dashboardData.upcomingExams.map((exam) => (
              <div key={exam.id} className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                <div>
                  <p className="font-medium text-slate-800">{exam.examName}</p>
                  <p className="text-sm text-slate-500">{exam.startDate} - {exam.endDate}</p>
                </div>
                <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                  Upcoming
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-slate-500 text-center py-8">No upcoming exams</p>
        )}
      </div>
    </div>
  );
}
